import React, { useEffect, useRef, useState } from 'react';
import { View, Text, Button, ScrollView } from '@tarojs/components';
import * as Taro from '@tarojs/taro';
import styles from './index.module.scss';

const Modal: React.FC<{ title: string; onClose: () => void; children: React.ReactNode; footer?: React.ReactNode; variant?: 'default' | 'quiz' }> = ({ title, onClose, children, footer, variant = 'default' }) => {
  const id = useRef('dialog-' + Math.random().toString(36).slice(2));
  const [bodyHeight, setBodyHeight] = useState('62vh');
  useEffect(() => {
    if (typeof Taro.createSelectorQuery !== 'function') return;
    Taro.createSelectorQuery().select('#' + id.current + '-body').boundingClientRect()
      .select('#' + id.current + '-header').boundingClientRect()
      .select('#' + id.current + '-footer').boundingClientRect().exec(results => {
        const [body, header, actions] = results as ({ height: number } | null)[];
        if (!body || !header) return;
        const window = Taro.getWindowInfo();
        setBodyHeight(Math.min(body.height, Math.max(80, window.windowHeight - header.height - (actions?.height || 0) - 88 * window.windowWidth / 750)) + 'px');
      });
  }, [children, footer]);
  return (
  <View className={styles.overlay} onClick={onClose} data-modal='true'>
    <View className={styles.panel + (variant === 'quiz' ? ' ' + styles.quizPanel : '')} onClick={event => event.stopPropagation()}>
      <View className={styles.header} id={id.current + '-header'}>
        <Text className={styles.title}>{title}</Text>
        <Button className={styles.close} onClick={onClose} aria-label='关闭弹窗'>×</Button>
      </View>
      <ScrollView className={styles.scroll} scrollY style={{ height: bodyHeight }}><View id={id.current + '-body'} className={styles.body}>{children}</View></ScrollView>
      {footer && <View id={id.current + '-footer'} className={styles.footer}>{footer}</View>}
    </View>
  </View>
  );
};
export default Modal;
